import { request } from '@/shared/api/request'

export const deleteDoc = (id) => {
	return request({ url: `assessment/contract/delete/${id}`, method: 'DELETE' })
}
